import styled from 'styled-components';
import { IC_DELIVERY_TRUCK, IC_EXPRESS_NEW,IC_FLASH, IC_EXPRESS_SHEDULED, IC_OFF_BOX, IC_POM_DELIVERY_BOY, IC_OFF_BOX_LEFT } from '../../Assets/images';

export const ProductItemStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: ${(props) => (props?.isGlobalCarousel ? '12px' : '0px')};

  .badgeStack {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px 0 0 10px;
    z-index: 1;
  }

  .offer-tost {
    width: 80px;
    height: 24px;
    color: ${(props) => props?.theme?.color?.white};
    font-weight: 700;
    background: url(${IC_OFF_BOX.src}) no-repeat 100% 50% / cover;
    display: flex;
    align-items: center;
    padding-left: ${(props) => props?.isPdpQuickView ? '0' : '6px'};
    margin-bottom: 6px;
    padding-right: ${(props) => props?.isPdpQuickView ? '0' : '12px'};
    direction: ltr;

    span {
      margin-left: 3px;
      font-size: 11px;
    }

    @media (max-width: 480px) {
      width: 67px;
      height: 20px;
      font-size: 13px;
    }
  }

  .ic-express {
    position: absolute;
    top: 40px;
    left: 0;
    img {
      border-radius: 0;
    }
  }
  .ic-express-top {
    position: absolute;
    top: 16px;
    left: 0;
    img {
      border-radius: 0;
    }
  }
  .link {
    color: ${(props) => props.theme.green.dark};
    &:hover {
      color: ${(props) => props.theme.green.light};
    }
  }
  .dealItemBox {
    width: 100%;
    max-width: 208px;
    margin-bottom: 16px;
    @media (max-width: 1024px) {
      max-width: 180px;
    }
    .item {
      width: 100%;
      min-height: 352px;
      padding: 8px;
      background: ${(props) => props.theme.color.white};
      border: 1px solid ${(props) => props.theme.color.lightGray};
      border-radius: 8px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      a {
        width: 100%;
        text-decoration: none;
        color: inherit;
      }
      .addToWishList {
        position: absolute;
        top: 16px;
        right: 16px;
        z-index: 10;

        img {
          border-radius: 0;
        }
      }

      .offTag {
        font-size: 13px;
        font-weight: 700;
        color: ${(props) => props.theme.color.white};
        background: ${(props) => props.theme.verification.red.main};
        padding: 5px 10px;
        border-radius: 8px 0;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
      .imgWrapper {
        width: 100%;
        text-align: center;
        position: relative;
        padding-bottom: 8px;
        margin-bottom: 8px;

        > div {
          width: 160px;
          height: 160px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .exclusive-wrapper {
        min-height: 32px;
        .exclusive {
          max-width: 152px;
          color: ${(props) => props.theme.color.white};
          background: ${(props) => props.theme.blue.dark}B3;
          font-size: 10px;
          font-weight: 700;
          padding: 5px 5px 5px 10px;
          text-transform: uppercase;
          position: relative;
          white-space: nowrap;
          margin: 0 0 8px 0;
          display: inline-flex;

          span {
            width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          &:before {
            border-top: 13px solid ${(props) => props.theme.blue.dark}4D;
            border-right: 10px solid transparent;
            border-left: 10px solid transparent;
            content: '';
            position: absolute;
            top: 0;
            left: 100%;
          }

          &:after {
            border-top: 25px solid transparent;
            border-right: 25px solid transparent;
            border-left: 20px solid ${(props) => props.theme.blue.dark}B3;
            content: '';
            position: absolute;
            bottom: 0;
            left: 100%;
          }
        }
      }

      .lowestPriceLabel {
        height: 20px;
        border-radius: 4px;
        background: ${(props) => props.theme.color.red};
      }

      .lowestPriceLabeltitle {
        height: 13px;
        font-size: 10px;
        line-height: 13px;
        text-align: left;
        color: #ffffff;
        padding: 3px 5px 0 5px;
        white-space: nowrap;
      }

      .discountEndsWrapper {
        width: 100% !important;
        height: 30px !important;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
        justify-content: space-between !important;
        align-items: flex-end !important;
        padding-top: 10px;

        .rating{
          position: relative;
          top: 0px;
        }
      }
      .discountEnds {
        background: ${(props) => props?.theme?.verification?.red?.off};
        padding: 6px;
        border-radius: 2px;
        display: inline-flex;
        justify-content: center;
        align-items: center;

        .timer {
          color: ${(props) => props?.theme?.color?.red};
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0;
          margin-left: 6px;
        }
      }
      .bundle-deal-cart{
        visibility: ${(props) => (props?.isBundle ? 'none' : 'hidden')};
        border-radius: 0px !important;
      }
      .pomProduct {
        visibility: ${(props) => (props?.isPOMEnabled ? 'none' : 'hidden')};
        border-radius: 0px !important;
      }
      .name {
        width: 100%;
        height: 40px;
        margin: 0 0 8px 0;
        font-size: 15px;
        font-weight: 600;
        overflow: hidden;
        word-break: break-all;
      }
      .price {
        width: 100%;
        margin: 0 0 8px 0;

        .new {
          font-size: 16px;
          font-weight: 700;
          margin: 0 5px 0 0;
          display: flex;
          column-gap: 5px;
        }
        .actual {
          color: ${(props) => props.theme.text.medium};
          font-size: 12px;
          font-weight: 600;
          text-decoration: line-through;
          display: flex;
          column-gap: 5px;
        }
      }
      .delivery {
        height: 24px;
        background: url(${IC_DELIVERY_TRUCK.src}) no-repeat 0 6px / 16px;
        color: ${(props) => props.theme.text.medium};
        font-size: 10px;
        font-weight: 600;
        text-align: left;
        padding: 3px 0 0 20px;
        margin: 0 0 8px 0;
        overflow: hidden;

        span {
          font-weight: 700;
        }

        &.pom {
          background: url(${IC_POM_DELIVERY_BOY.src}) no-repeat 0 3px;
          background-size: 19.288px 16px;
          padding-left: 22px;
          span {
            font-weight: 600;
          }
        }

        &.scheduled{
          background: url(${IC_EXPRESS_SHEDULED.src}) no-repeat 0 5px / 36px;
          padding-left: 40px;

          span {
            font-weight: 600;
          }
        }
        &.express {
          background: url(${IC_EXPRESS_NEW.src}) no-repeat 0 5px / 36px;
          padding-left: 40px;

          span {
            font-weight: 600;
          }
        }

        &.flash {
          background: url(${IC_FLASH.src}) no-repeat 0 3px / 36px;
          padding-left: 38px;

          span {
            font-weight: 600;
          }
        }
        .delivery-text {
          background: ${(props) => props.theme.green.medium};
          font-weight: 700 !important;
          border-radius: 4px;
          padding: 1px 4px;
        }
      }
    }
    .add-to-card {
      position: absolute;
      bottom: 0px;
      .col-lg-12 {
        padding-left: 0;
      }
      .quantity-wrapper {
        position: relative;
        margin-bottom: 11px;
        margin-right: 8px;
        .txtLoading {
          .dropdown-wrapper {
            &.dropdown {
              .dropdown-toggle {
                font-size: 11px;
              }
            }
          }
        }
        .dropdown-wrapper {
          &.dropdown {
            .dropdown-toggle {
              text-align: center;
              font-weight: 700;
              font-size: 17px;
              color: ${(props) => props.theme.green.dark};
              border: 1px solid ${(props) => props?.theme?.colors?.neutral?.darkBlue?.['50']};
              border-radius: 100px;
              width: 107px;
              height: 43px;
              padding: 8px 30px 8px 30px;
              &:after {
                display: none;
              }
            }
            .dropdown-menu {
              &.show {
                a {
                  display: none;
                }
              }
            }
          }
        }
        .decrease-product {
          width: 35px;
          position: absolute;
          top: 4px;
          left: 4px;
          cursor: pointer;
          pointer-events: none;
        }

        .increase_product {
          width: 35px;
          position: absolute;
          top: 4px;
          right: 4px;
          cursor: pointer;
        }
      }
      .disabled {
        pointer-events: none !important;
      }
    }

    .add-to-card.ltr {
      right: 0px;
    }

    .outofstock {
      height: 24px;
      font-size: 13px;
      overflow: hidden;
      color: ${(props) => props?.theme?.colors?.secondary?.orange?.["700"]};
    }
  }

  &.inProductList {
    .dealItemBox {
      .item {
        padding: 8px;
      }
    }
  }

  @media (max-width: 820px) {
    padding: 0;

    .dealItemBox {
      max-width: unset;
      margin: 0 6px;
    }
  }

  @media (max-width: 480px) {
    .row {
      .col-lg-12 {
        padding: 0;
      }
    }

    .dealItemBox {
      max-width: 100%;
      margin: 0;

      .item {
        padding: 10px;
        border-radius: 0;
        border-left: 0;
        border-top: 0;

        .bundle-deal-cart{
        padding-top: 133px;
      }

        .pomProduct {
          padding-top: 133px;
          padding-right: 20px;
        }

        .badgeStack {
          .wrapper {
            font-size: 11px;
          }
        }
        .addToWishList {
          top: 10px;
          right: 10px;
        }
        .imgWrapper {
          padding-bottom: 8px;
          > div {
            width: 160px !important;
            height: 160px !important;
          }
        }
        .name {
          height: 50px;
          font-size: 14px;
          line-height: 17px;
          margin-bottom: 2px;
        }
        .price {
          font-size: 13px;
          margin-bottom: 2px;

          .new {
            font-size: 14px;
          }
        }
        .delivery {
          height: 30px;
          background-position: 0 5px;
          font-size: 10px;
          line-height: 14px;
          margin-bottom: 4px;
        }
        .add-to-card {
          .quantity-wrapper {
            margin-bottom: 11px;
            margin-right: 11px;
            .dropdown-wrapper.dropdown {
              .dropdown-toggle {
                font-size: 13px;
                padding: 5px 30px;
              }
              .txtLoading {
                font-size: 12px;
              }
            }
            .decrease-product {
              width: 38px;
              height: 38px;
              left: 3px;
              top: 3px;

              img {
                border-radius: 0;
              }
            }
            .increase_product {
              width: 38px;
              height: 38px;
              right: 3px;
              top: 3px;

              img {
                border-radius: 0;
              }
            }
          }
          .btn {
            font-size: 12px;
            padding: 5px 10px;
          }
        }
        .outofstock {
          height: 30px;
          font-size: 12px;
          margin-bottom: 4px !important;
          color: ${(props) => props?.theme?.colors?.secondary?.orange?.['700']};
        }
      }
    }
  }
  @media (max-width: 380px) {
    .slick-slide {
      width: 65vw !important;
    }
  }
  @media (max-width: 430px) {
    .dealItemBox {
      .item {
        .imgWrapper {
          > div {
            width: 187px !important;
          }
        }
      }
    }

  }
  @media (max-width: 390px) {
    .dealItemBox {
      .item {
        .imgWrapper {
          > div {
            width: 160px !important;
          }
        }
      }
    }
  }
  @media (max-width: 360px) {
    .dealItemBox {
      .item {
        .imgWrapper {
          > div {
            width: 160px !important;
          }
        }
      }
    }
  }

  &.rtl {
    .dealItemBox {
      .item {
        .delivery {
          display: table;
        }
        .price {
          .new {
            justify-content: end;
          }
          .actual {
            justify-content: end;
          }
        }
        .addToWishList {
          left: 16px;
          right: auto;
        }      
      }
      .badgeStack {
        right: 0;
        left: auto;
        padding: 10px 10px 0 0;
        .offer-tost {
          padding-left: 12px;
          padding-right: 6px;
          background: url(${IC_OFF_BOX_LEFT.src}) no-repeat;
          background-size: cover;
          background-position: left;
          justify-content: end;
        }
      }
    }
  }
`;
